
const estadosMexico = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Coahuila",
  "Colima",
  "Durango",
  "Estado de México",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "Michoacán",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz",
  "Yucatán",
  "Zacatecas",
];

const Step1Form = ({ data, onChange }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(name, value); // ✅ match parent signature
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="bg-primary-green p-5 rounded-lg w-full">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-white font-bold text-xs mb-1">
              Nombre (s):
            </label>
            <input
              type="text"
              name="nombre"
              value={data.nombre}
              onChange={handleChange}
              className="w-full px-2 py-1.5 rounded text-black text-sm"
              placeholder="Nombre"
            />
          </div>
          <div>
            <label className="block text-white font-bold text-xs mb-1">
              Apellido paterno:
            </label>
            <input
              type="text"
              name="apellidoPaterno"
              value={data.apellidoPaterno}
              onChange={handleChange}
              className="w-full px-2 py-1.5 rounded text-black text-sm"
              placeholder="Primer apellido"
            />
          </div>
          <div>
            <label className="block text-white font-bold text-xs mb-1">
              Apellido materno:
            </label>
            <input
              type="text"
              name="apellidoMaterno"
              value={data.apellidoMaterno}
              onChange={handleChange}
              className="w-full px-2 py-1.5 rounded text-black text-sm"
              placeholder="Segundo apellido"
            />
          </div>
          <div>
            <label className="block text-white font-bold text-xs mb-1">
              WhatsApp:
            </label>
            <input
              type="text"
              name="whatsapp"
              value={data.whatsapp}
              onChange={handleChange}
              className="w-full px-2 py-1.5 rounded text-black text-sm"
              placeholder="XXX XXX XXXX"
            />
          </div>
        </div>

        <div>
          <label className="block text-white font-bold text-xs mb-1">
            Correo electrónico:
          </label>
          <input
            type="email"
            name="correo"
            value={data.correo}
            onChange={handleChange}
            className="w-full px-2 py-1.5 rounded text-black text-sm"
            placeholder="ejemplo@ejemplo.com"
          />
        </div>

        <div>
          <label className="block text-white font-bold text-xs mb-1">
            Estado:
          </label>
          <select
            name="estado"
            value={data.estado}
            onChange={handleChange}
            className="w-full px-2 py-1.5 rounded text-black text-sm"
          >
            <option value="">Estado</option>
            {estadosMexico.map((estado) => (
              <option key={estado} value={estado}>
                {estado}
              </option>
            ))}
          </select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <label className="block text-white font-bold text-xs mb-1">
              Municipio / Delegación:
            </label>
            <input
              type="text"
              name="municipio"
              value={data.municipio}
              onChange={handleChange}
              className="w-full px-2 py-1.5 rounded text-black text-sm"
              placeholder="Municipio"
            />
          </div>
          <div>
            <label className="block text-white font-bold text-xs mb-1">
              Código postal:
            </label>
            <input
              type="text"
              name="cp"
              value={data.cp}
              onChange={handleChange}
              className="w-full px-2 py-1.5 rounded text-black text-sm"
              placeholder="XXXXX"
            />
          </div>
        </div>

        <div>
          <label className="block text-white font-bold text-xs mb-1">
            Nombre de tu taller, negocio o empresa:
          </label>
          <input
            type="text"
            name="taller"
            value={data.taller}
            onChange={handleChange}
            className="w-full px-2 py-1.5 rounded text-black text-sm"
            placeholder="Nombre de tu taller"
          />
        </div>
      </div>

      <p className="text-white text-xs md:text-xl md:text-left text-center">
        Con esta información podremos brindarte acceso a la plataforma.
      </p>
    </div>
  );
};

export default Step1Form;
